import { mapGetters } from "vuex";

export default {
  data() {
    return {
      slidesToShowNav: 0,
      settings: {
        arrows: true,
        dots: true,
        fade: true,
        edgeFriction: 0.35,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        touchMove: false,
        swipe: false,
        responsive: [
          {
            breakpoint: 1100,
            settings: {
              // Issue to scroll over slides
              /* touchMove: true,
              swipe: true, */
            }
          },
        ],
      },
      settingsFor: {
        arrows: true,
        speed: 500,
        slidesToShow: 4,
        focusOnSelect: true,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        touchMove: false,
        swipe: false,
      },
      settingsForZeborne: {
        arrows: true,
        speed: 500,
        slidesToShow: 4,
        focusOnSelect: true,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        touchMove: false,
        swipe: false,
        responsive: [
          {
            breakpoint: 1100,
            settings: {
              vertical: false,
              verticalSwiping: false,
              touchMove: true,
              swipe: true,
              arrows: false,
              focusOnSelect: true,
            }
          },
        ],
      },
      settingsForCart: {
        arrows: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: false,
        
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              touchMove: true,
              swipe: true,
            }
          },
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 3,
              touchMove: true,
              swipe: true,
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 450,
            settings: {
              slidesToShow: 1,
              centerMode: true,
            }
          },
        ],
      },
      settingsForMegaMenu: {
        arrows: true,
        speed: 500,
        slidesToShow: 5,
        focusOnSelect: false,
        slidesToScroll: 1,
        infinite: false,
        rows: 2,
        centerPadding: 20,
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 4,
            }
          },
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 3,
            }
          },
        ]
      },
      settingForZblocks: {
          arrows: true,
          infinite: false,
          slidesToShow: 4,
          rows: 2,
          centerPadding: 20,
          responsive: [
              {
                  breakpoint: 1400,
                  settings: {
                      slidesToShow: 3,
                  }
              },
              {
                  breakpoint: 1100,
                  settings: {
                      slidesToShow: 2,
                  }
              },
          ]
      },
      settingForBlogHomeZBlock: {
        arrows: true,
        infinite: false,
        slidesToShow: 4,
        responsive: [
          {
              breakpoint: 1200,
              settings: {
                  slidesToShow: 3,
              }
          },
          {
              breakpoint: 1000,
              settings: {
                  slidesToShow: 2,
              }
          },
          {
            breakpoint: 700,
            settings: {
                slidesToShow: 1,
            }
        },
      ]
      }
    };
  },

  methods: {
    slideNav(event) {
      const clickedIndex = event.currentTarget.parentElement.parentElement.getAttribute(
        "data-index",
      );
      this.$refs.SliderFor.goTo(clickedIndex);
    },
  },

  computed: {
    ...mapGetters({ productName: "getProductName" }),
    ...mapGetters({ productVideos: "getProductVideos" }),
  },

  created() {
    if(this.productGallery) {
      this.slidesToShowNav = this.productGallery.images.length;
    }
  },
};
